/**
 * Provides boolean value as to whether the user is already in recovery (has already recovered username).
 * This allows presenting just the Forgot Password link (no Forgot Username link) so that the user
 * can quickly do a password reset immediately in recovery (if the recovery session is valid).
 */
import React, { useMemo } from 'react'
import RecoveryContext from './RecoveryContext'

export default function UrlAfterLoginProvider({ children }) {
  const isRecovery = useMemo(() => {
    const searchParams = new URLSearchParams(window.location.search)
    // prompt can be multiple values that are comma separated
    return !!(searchParams.get('username') && searchParams.get('prompt')?.includes('recovery'))
  }, [])
  return <RecoveryContext.Provider value={isRecovery}>{children}</RecoveryContext.Provider>
}
